import IconFilter from '../Icons/IconFilter';
import { useFilters } from '../../providers/FiltersProvider';

import SelectedTermsCounter from './shared/SelectedTermsCounter';

const ToggleFiltersButton = ({ additionalClasses = '' }) => {
  const { showFilters, setShowFilters, totalSelected } = useFilters();

  const filterBg = showFilters
    ? 'bg-[#3722D3] text-white'
    : 'bg-white border border-[#DCDEE1] hover:border-[#3722D3] hover:text-[#3722D3] hover:bg-white';

  const handleToggleFilters = () => {
    setShowFilters(!showFilters);
  };

  return (
    <button
      className={`flex h-[41px] py-[8px] px-[16px] border rounded-[50px] ${filterBg} text-[14px] leading-[22.4px] text-gray-800  ${additionalClasses}`}
      onClick={handleToggleFilters}
    >
      {totalSelected > 0 ? (
        <SelectedTermsCounter
          filtersAreOpen={!showFilters}
          lightTheme={true}
          additionalClasses="mr-[12px]"
          total={totalSelected}
        />
      ) : (
        <span className="inline-block h-[20px] mr-[12px] align-middle">
          <IconFilter />
        </span>
      )}
      <span>Filters</span>
    </button>
  );
};
export default ToggleFiltersButton;
